export default __webpack_public_path__ + "static/media/A5_LANDSCAPE_COPY.ed9cbea2.png";